"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import DetailsBox from "~/components/job-page/jobadtemplate/details-box-eon";
import { LocationDisplay } from "~/components/ui/location-display-eon";
import { PrintDropdown } from "~/components/ui/print-dropdown-eon";
import ShareDropdown from "~/components/ui/share-dropdown-eon";
import { WatchJobButton } from "~/components/ui/watch-job-button-eon";
import { toSimilarJob } from "~/lib/utils/to-similar-job";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function JobAdTemplateManualJob(t0) {
  const $ = _c(47);
  const {
    job
  } = t0;
  const t = useLanguage();
  const data = job.data;
  let t1;
  if ($[0] !== data.title) {
    t1 = <h2 className="mb-4 font-bold text-4xl text-primary md:text-5xl">{data.title}</h2>;
    $[0] = data.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !data.locations || data.locations.length === 1 ? `${t.jobad_locationDisplay_single}: ` : `${t.jobad_locationDisplay_multi}: `;
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="font-medium" data-source="lc">{t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== job) {
    t4 = <LocationDisplay job={job} showAll={true} />;
    $[4] = job;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="text-lg">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("mt-6 grid-cols-2 gap-x-24 text-foreground text-xl md:text-lg lg:grid xl:gap-x-32", "[&_p+p]:mt-4", "[&_p:not(li>p)]:mb-4", "[&_h3]:mt-6 [&_h3]:font-bold", "overflow-wrap-break-word");
    t7 = {
      gridTemplateColumns: "minmax(0, 1fr) 400px"
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t.jobad_description_HL) {
    t8 = <h3 className="mt-6 font-bold text-xl" data-source="lc">{t.jobad_description_HL}</h3>;
    $[11] = t.jobad_description_HL;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== job.content.task || $[14] !== job.content.taskHL) {
    t9 = job.content.task && <div className="mt-6">{job.content.taskHL && <h3 className="font-bold" data-source="job">{job.content.taskHL}</h3>}<div dangerouslySetInnerHTML={{
        __html: job.content.task
      }} data-source="job" /></div>;
    $[13] = job.content.task;
    $[14] = job.content.taskHL;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== job.content.offer) {
    t10 = job.content.offer && <div className="mt-8 lg:hidden"><h3 className="font-bold text-xl" data-source="job">Balanced Scorecard</h3><div className={cn("mt-4 w-full overflow-x-auto overscroll-x-contain", "[&_table]:w-full [&_table]:border-collapse [&_table]:text-sm md:[&_table]:text-base", "[&_col]:![width:auto]", "[&_th]:border [&_th]:border-gray-300 [&_th]:bg-gray-100 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:align-top [&_th]:font-semibold", "[&_td]:border [&_td]:border-gray-300 [&_td]:px-3 [&_td]:py-2 [&_td]:align-top [&_td]:[overflow-wrap:break-word]", "[&_td:first-child]:bg-gray-100 [&_tr:first-child_td]:bg-gray-100")} dangerouslySetInnerHTML={{
        __html: job.content.offer
      }} data-source="job" /></div>;
    $[16] = job.content.offer;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8 || $[20] !== t9) {
    t11 = <div>{t8}{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== job) {
    t12 = <DetailsBox job={job} />;
    $[22] = job;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== job.data) {
    t13 = toSimilarJob(job.data);
    $[24] = job.data;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <WatchJobButton jobData={t13} variant="purple" />;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== job) {
    t15 = <ShareDropdown job={job} variant="purple" />;
    $[28] = job;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PrintDropdown asButton={true} variant="purple" />;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t14 || $[32] !== t15) {
    t17 = <section className="mt-4 grid h-10 grid-flow-col grid-cols-3 gap-4 text-white [&_button]:rounded-[var(--filtermenu-radius)]">{t14}{t15}{t16}</section>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t12 || $[35] !== t17) {
    t18 = <div className="flex flex-col">{t12}{t17}</div>;
    $[34] = t12;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t11 || $[38] !== t18) {
    t19 = <div className={t6} style={t7}>{t11}{t18}</div>;
    $[37] = t11;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== job.content.offer) {
    t20 = job.content.offer && <div className="mt-8 hidden lg:block"><h3 className="font-bold text-xl" data-source="job">Balanced Scorecard</h3><div className={cn("mt-4 w-full", "[&_table]:w-full [&_table]:table-fixed [&_table]:border-collapse [&_table]:text-base", "[&_col]:![width:auto]", "[&_th]:border [&_th]:border-gray-300 [&_th]:bg-gray-100 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:align-top [&_th]:font-semibold", "[&_td]:border [&_td]:border-gray-300 [&_td]:px-3 [&_td]:py-2 [&_td]:align-top [&_td]:[overflow-wrap:break-word]", "[&_td:first-child]:bg-gray-100 [&_tr:first-child_td]:bg-gray-100")} dangerouslySetInnerHTML={{
        __html: job.content.offer
      }} data-source="job" /></div>;
    $[40] = job.content.offer;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t1 || $[43] !== t19 || $[44] !== t20 || $[45] !== t5) {
    t21 = <section className="grid w-full justify-center py-10 md:py-20 print:hidden" id="job" tabIndex={-1}><div className="mx-6 min-w-0 max-w-screen-xl md:mx-10">{t1}{t5}{t19}{t20}</div></section>;
    $[42] = t1;
    $[43] = t19;
    $[44] = t20;
    $[45] = t5;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  return t21;
}